const fadeOut = (el: HTMLElement) => {
  el.classList.add("hide");
  el.classList.remove("show");
};

const fadeIn = (el: HTMLElement) => {
  el.classList.add("show");
  el.classList.remove("hide");
};

function closeModal(modal: HTMLElement, enableAnchors: boolean) {
  if (enableAnchors) {
    const {origin, pathname} = window.location;
    window.location.href = origin + pathname + "#research-citations";
    fadeOut(modal);
  }
}

function openModal(dataset: {
  fullDescription: string;
  imageUrl: string;
  title: string;
  date: string;
  company: string;
  id: string;
}) {
  const {title, imageUrl, company, date, fullDescription} = dataset;
  const modal = document.getElementById("citation-modal");

  if (!modal) {
    return;
  }

  document.getElementById("modal-title")!.innerHTML = title;
  (document.getElementById("modal-image")! as HTMLImageElement).src = imageUrl;
  document.getElementById("modal-company")!.innerHTML = company;
  document.getElementById("modal-date")!.innerHTML = date;
  document.getElementById("modal-description")!.innerHTML = fullDescription;
  fadeIn(modal);
}

function openFromHref(items: NodeListOf<Element>) {
  const anchorParse = window.location.href.split("#");
  if (anchorParse.length !== 2) {
    return;
  }

  const anchor = anchorParse[1];
  const splitIdx = anchor.indexOf("_");
  const itemId = splitIdx !== -1 ? anchor.substring(splitIdx + 1) : undefined;
  if (itemId === undefined) {
    return;
  }

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const dataset = (item as any).dataset;
    if (itemId === dataset.id) {
      openModal(dataset);
    }
  }
}

export function setupResearchCitations(options?: {enableAnchors?: boolean}) {
  const enableAnchors = options?.enableAnchors ?? false;
  const modal = document.getElementById("citation-modal");
  const items = document.querySelectorAll("a[data-resource-type='research-citations']");

  if (!modal) {
    return;
  }

  if (enableAnchors) {
    openFromHref(items);
  }

  for (let i = 0; i < items.length; i++) {
    items[i].addEventListener(
      "click",
      (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();

        if (enableAnchors) {
          const {id} = ev.currentTarget.dataset;
          const {origin, pathname} = window.location;
          window.location.href = origin + pathname + "#research-citations_" + id;
        }

        openModal(ev.currentTarget.dataset);
      },
      false,
    );
  }

  if (!modal) {
    return;
  }

  // Hide modal on X click
  document.getElementById("close-modal")!.addEventListener(
    "click",
    (ev) => {
      closeModal(modal, enableAnchors);
    },
    false,
  );

  // Hide modal on out click
  window.addEventListener("mouseup", function (event: any) {
    const modalBody = modal.children[0];
    const clickOutsideModal = modalBody !== event.target && !modalBody.contains(event.target);
    if (modal.classList.contains("show") && clickOutsideModal) {
      closeModal(modal, enableAnchors);
    }
  });
}
